import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageLoader from '../components/loader/LoaderText';
import { NAVIGATE_AUTH } from '../constant';
import AuthLayout from '../layout/AuthLayout';

const Error404 = lazy(() => import('../pages/error/Error404'));

const LoginPage = lazy(() => import('../pages/auth/login'));

const AuthRoute = () => {
    return (
        <Suspense fallback={<AuthLayout><PageLoader /></AuthLayout>}>
            <Routes>
                <Route path='*' element={<Error404 />}></Route>
                <Route path={NAVIGATE_AUTH.LOGIN} element={<AuthLayout><LoginPage /></AuthLayout>}></Route>
            </Routes>
        </Suspense>
    )
}

export default AuthRoute;